import { Link, Route, Routes } from "react-router-dom";
import Login from "./Views/Login";
import loader from "./Assets/Images/loader.png";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { ToastContainer } from "react-toastify";
import Home from "./Views/Home";
import AllFreelancers from "./Views/AllFreelancers";
import AllProviders from "./Views/AllProviders";
import IndividualDetail from "./Views/IndividualDetail";
import Register from "./Views/Register";
import Account from "./Views/Account";
import Contact from "./Views/Contact";
import Profile from "./Views/Profile";
import CompanyDetail from "./Views/CompanyDetail";
import Pricing from "./Views/Pricing";
import Aboutus from "./Views/Aboutus";
import Terms from "./Views/Terms";
import Privacy from "./Views/Privacy";
import News from "./Views/News";
import Course from "./Views/Course";
import AntiDiscrimination from "./Views/Antidiscrimination";
import FAQ from "./Views/Faq";
import Preview from "./Views/Preview";
import ForgotPassword from "./Views/forgotpasword";
import Token from "./Views/token";
import OrderSuccessPayment from "./Views/OrderSuccessPayment";
// Import the new ViewProfile component
import ViewProfile from "./Views/ViewProfile";
import DocumentUpload from "./Views/documentupload";

function App() {
  // Get the userType from localStorage (or wherever you are storing the user's info)
  const userType = localStorage.getItem("userType"); // "individual" or "company"
  const usertypecategory = localStorage.getItem("usertypecategory")

  return (
    <div
      className="horizontalMenucontainer"
      style={window.innerWidth < 700 ? { minWidth: 375 } : {}}
    >
      <ToastContainer />
      <div id="global-loader" style={{ display: "none" }}>
        <img src={loader} className="loader-img floating" alt="" />
      </div>
      <Header />
      <Routes>
        <Route path="/token/:token" element={<Token />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register/:type" element={<Register />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/account/*" element={<Account />} />
        <Route path="/documentbank" element={<DocumentUpload />} />
        <Route path="/allfreelancers" element={<AllFreelancers />} />
        <Route path="/allproviders" element={<AllProviders />} />

        {/* Dynamically render ViewProfile based on userType */}
        <Route
          path="/view-profile"
          element={
            usertypecategory === "Company" ? (
              <CompanyDetail /> // Render CompanyDetail if userType is company
            ) : (
              <IndividualDetail /> // Render IndividualDetail if userType is individual
            )
          }
        />

        <Route path="/individual/:memberid" element={<IndividualDetail />} />
        <Route path="/company/:memberid" element={<CompanyDetail />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/antidiscrimination" element={<AntiDiscrimination />} />
        <Route path="/news" element={<News />} />
        <Route path="/course" element={<Course />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/preview/:type" element={<Preview />} />
        <Route
          path="/ordersuccesspayment/:title/:message"
          element={<OrderSuccessPayment />}
        />
      </Routes>
      <Footer />
      <div
        className="product-filter-icons text-center"
        style={{
          position: "fixed",
          right: 0,
          top: "40%",
          zIndex: 99,
          flexDirection: "column",
          display: "flex",
        }}
      >
        <Link
          className="apss-single-icon mb-1 rot-icon"
          to="/register/freelancer"
          target="_blank"
        >
          <div
            className="bg-green text-white"
            style={{
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
              padding: "10px 5px",
            }}
          >
            Post Your Services
          </div>
        </Link>
        <Link
          to={"/register/company"}
          target="_blank"
          className="apss-single-icon mb-1 rot-icon"
        >
          <div
            className="bg-primary text-white"
            style={{
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
              padding: "10px 5px",
            }}
          >
            Post Your Requirements
          </div>
        </Link>
      </div>
    </div>
  );
}

export default App;
